import React from "react";
import styled from 'styled-components';
import Logo from "../../components/logos/Logo/Logo";
import SectionButton from "../../components/section-items/SectionButton/SectionButton";

const NotFoundText = styled.p`
    font-size: 30px;
    font-family: BlenderProBold;
    margin: 25px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

const NotFoundContainer = () => {
    return (<Container>
        <Logo width={250} height={250}/>
        <NotFoundText>{'Nie znaleziono podanej strony.'}</NotFoundText>
        <SectionButton text={'POWRÓĆ DO STRONY GŁÓWNEJ'}
                       section={'start'}
                       color={'black'}
                       backgroundColor={'transparent'}
                       style={{margin: 25, marginTop: 30}}
        />
    </Container>);
};

export default NotFoundContainer;
